import { BaseEntityLineChart } from '../../../components/Charts';
import { useProvincesChart } from '../hooks/useProvincesChart';
import { useAppSelector } from '../../../store/hooks';

interface ProvincesChartProps {
	height?: number;
}

export function ProvincesChart({ height = 400 }: ProvincesChartProps) {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const { nivoData, isLoading, error } = useProvincesChart({
		filters: {
			maKhoa: selectedFaculty ? [selectedFaculty] : undefined
		}
	});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Tỉnh thành"
			downloadFilename="bieu-do-tinh-thanh"
			entityLabel="Chọn tỉnh thành"
			entityPlaceholder="Tất cả tỉnh thành"
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
